/*
Adapted from https://usehooks.com/useScript/

We had to lose the hooks because we wanted to run this in an async context,
not necessarily the component.  So we've stripped it back, and lost the knowledge
of whether a script has loaded.
*/

const loadedScripts: string[] = [];

/* eslint-disable sonarjs/cognitive-complexity */
function useScript(src: string): Promise<void> {
  return new Promise((resolve) => {
    // Fetch existing script element by src
    // It may have been added by another intance of this hook
    let script: HTMLScriptElement | null = document.querySelector(`script[src="${src}"]`);

    if (script) {
      // Script has already been added to document, don't add again
      resolve();
      return;
    }
    if (loadedScripts.includes(src)) {
      // Browser hasn't found the script, but we have tried to load it.
      // Failsafe to prevent double load of script
      resolve();
      return;
    }

    // Create script
    script = document.createElement("script");
    script.src = src;
    script.async = true;

    // Add script to document body
    document.body.append(script);
    loadedScripts.push(src);

    script.addEventListener("load", () => resolve());
  });
}

export default useScript;
